// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qeJiF","loadingWrap":"styles_loadingWrap__hrNNh"};